// extracted by css-extract-rspack-plugin
export default {"relationshipBadge":"RelatedOrganisations_relationshipBadge__+wt-R"};